import React from 'react';
import { Link } from 'react-router-dom';
import { TrustSection } from '../components/TrustSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { MapPinIcon, ClockIcon, PhoneIcon, ShieldCheckIcon, UsersIcon, WrenchIcon, HeartIcon } from 'lucide-react';
export function AboutPage() {
  return <div data-id="element-608">
      {/* Page Header */}
      <div className="relative py-24 px-4 sm:px-6 lg:px-8 text-center overflow-hidden" style={{
      background: '#000000'
    }} data-id="element-609">
        <img src="https://images.unsplash.com/photo-1531384441138-2736e62e0919?w=1600&q=80" alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover opacity-20" data-id="element-610" />
        <div className="relative z-10" data-id="element-611">
          <p className="text-xs font-bold uppercase mb-3" style={{
          color: '#CC0000',
          letterSpacing: '0.2em'
        }} data-id="element-612">
            Since 1995
          </p>
          <h1 className="text-4xl sm:text-6xl font-black text-white mb-4" data-id="element-613">
            About Ameritech Tires
          </h1>
          <div className="w-12 h-0.5 mx-auto mb-6" style={{
          background: '#FECB00'
        }} data-id="element-614" />
          <p className="text-gray-400 text-base max-w-xl mx-auto leading-relaxed" data-id="element-615">
            Over 30 years of trusted tire service in the DMV area. Family-owned,
            community-focused, open 24/7.
          </p>
        </div>
      </div>

      {/* Our Story — 2 col */}
      <section className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-616">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-617">
          <div data-id="element-618">
            <p className="text-xs font-bold uppercase mb-4" style={{
            color: '#CC0000',
            letterSpacing: '0.2em'
          }} data-id="element-619">
              Our Story
            </p>
            <h2 className="font-black text-black text-3xl sm:text-4xl leading-tight mb-6" data-id="element-620">
              30 Years of Keeping the DMV Moving
            </h2>
            <div className="w-10 h-0.5 mb-6" style={{
            background: '#FECB00'
          }} data-id="element-621" />
            <p className="text-base leading-relaxed mb-4" style={{
            color: '#616365'
          }} data-id="element-622">
              Ameritech Tires was founded in 1995 with a simple mission: provide
              the DMV community with fast, honest, and affordable tire service.
              What started as a single location in Cottage City, Maryland has
              grown into three full-service tire shops serving thousands of
              drivers every year.
            </p>
            <p className="text-base leading-relaxed mb-4" style={{
            color: '#616365'
          }} data-id="element-623">
              We've built our reputation on trust. No upsells, no surprises —
              just straight talk and quality work. Our technicians are certified
              professionals who treat every vehicle like it's their own.
            </p>
            <p className="text-base leading-relaxed mb-8" style={{
            color: '#616365'
          }} data-id="element-624">
              We're proud to be a community staple across Cottage City, Capitol
              Heights, and Suitland. When you need tires — day or night —
              Ameritech is here.
            </p>
            <Link to="/contact" className="inline-block text-white font-black text-sm uppercase tracking-widest px-8 py-4 transition-colors duration-200" style={{
            background: '#CC0000',
            letterSpacing: '0.12em'
          }} onMouseEnter={e => e.currentTarget.style.background = '#AA0000'} onMouseLeave={e => e.currentTarget.style.background = '#CC0000'} data-id="element-625">
              Get in Touch
            </Link>
          </div>
          <div className="grid grid-cols-2 gap-3" data-id="element-626">
            <div className="overflow-hidden h-72" data-id="element-627">
              <img src="https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=500&q=80" alt="Ameritech Tires shop" className="w-full h-full object-cover" data-id="element-628" />
            </div>
            <div className="overflow-hidden h-72 mt-8" data-id="element-629">
              <img src="https://images.unsplash.com/photo-1607990281513-2c110a25bd8c?w=500&q=80" alt="Tire service" className="w-full h-full object-cover" data-id="element-630" />
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Values */}
      <section className="w-full py-20 px-4 sm:px-6 lg:px-8" style={{
      background: '#111111'
    }} data-id="element-631">
        <div className="max-w-7xl mx-auto" data-id="element-632">
          <div className="text-center mb-14" data-id="element-633">
            <p className="text-xs font-bold uppercase mb-3" style={{
            color: '#CC0000',
            letterSpacing: '0.2em'
          }} data-id="element-634">
              What We Stand For
            </p>
            <h2 className="font-black text-white text-3xl sm:text-4xl" data-id="element-635">
              Our Mission &amp; Values
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-636">
            {[{
            icon: ShieldCheckIcon,
            title: 'Honesty First',
            body: 'We tell you exactly what your vehicle needs — nothing more, nothing less. Transparent pricing, always.'
          }, {
            icon: WrenchIcon,
            title: 'Expert Craft',
            body: 'Certified technicians with decades of experience handle every job with precision and care.'
          }, {
            icon: ClockIcon,
            title: 'Respect Your Time',
            body: 'Most services done in under 45 minutes. No appointments, no waiting in long queues.'
          }, {
            icon: HeartIcon,
            title: 'Community First',
            body: "We've served DMV families for 30+ years. Our neighbors are our customers, and we treat them like family."
          }].map(({
            icon: Icon,
            title,
            body
          }, idx) => <div key={title} className="p-8" style={{
            background: '#1a1a1a',
            borderTop: `3px solid ${idx % 2 === 0 ? '#CC0000' : '#1A3BCC'}`
          }} data-id="element-637">
                <div className="w-12 h-12 rounded-full flex items-center justify-center mb-5" style={{
              background: idx % 2 === 0 ? 'rgba(204,0,0,0.20)' : 'rgba(26,59,204,0.20)'
            }} data-id="element-638">
                  <Icon size={20} style={{
                color: idx % 2 === 0 ? '#CC0000' : '#1A3BCC'
              }} data-id="element-639" />
                </div>
                <h3 className="font-black text-white text-base mb-3" data-id="element-640">
                  {title}
                </h3>
                <p className="text-sm leading-relaxed" style={{
              color: '#616365'
            }} data-id="element-641">
                  {body}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* By the Numbers */}
      <TrustSection data-id="element-642" />

      {/* Our Locations */}
      <section className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-643">
        <div className="max-w-7xl mx-auto" data-id="element-644">
          <div className="text-center mb-14" data-id="element-645">
            <p className="text-xs font-bold uppercase mb-3" style={{
            color: '#CC0000',
            letterSpacing: '0.2em'
          }} data-id="element-646">
              Find Us
            </p>
            <h2 className="font-black text-black text-3xl sm:text-4xl" data-id="element-647">
              3 Convenient DMV Locations
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-648">
            {[{
            name: 'Cottage City',
            address: '4014 Bladensburg Rd, Cottage City, MD 20722',
            maps: 'https://maps.google.com/?q=4014+Bladensburg+Rd+Cottage+City+MD+20722'
          }, {
            name: 'Capitol Heights',
            address: '1205 Marblewood Ave, Capitol Heights, MD 20743',
            maps: 'https://maps.google.com/?q=1205+Marblewood+Ave+Capitol+Heights+MD'
          }, {
            name: 'Suitland',
            address: '4510 Suitland Rd, Suitland, MD 20746',
            maps: 'https://maps.google.com/?q=4510+Suitland+Rd+Suitland+MD'
          }].map((loc, idx) => <div key={loc.name} className="p-8 shadow-[0_2px_16px_rgba(0,0,0,0.08)]" style={{
            borderLeft: `4px solid ${idx % 2 === 0 ? '#CC0000' : '#1A3BCC'}`
          }} data-id="element-649">
                <div className="flex items-center gap-3 mb-4" data-id="element-650">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                background: idx % 2 === 0 ? 'rgba(204,0,0,0.10)' : 'rgba(26,59,204,0.10)'
              }} data-id="element-651">
                    <MapPinIcon size={18} style={{
                  color: idx % 2 === 0 ? '#CC0000' : '#1A3BCC'
                }} data-id="element-652" />
                  </div>
                  <h3 className="font-black text-black text-lg" data-id="element-653">{loc.name}</h3>
                </div>
                <p className="text-sm mb-3 leading-relaxed" style={{
              color: '#616365'
            }} data-id="element-654">
                  {loc.address}
                </p>
                <div className="flex items-center gap-2 mb-5" data-id="element-655">
                  <ClockIcon size={14} className="text-green-500" data-id="element-656" />
                  <span className="text-green-600 font-semibold text-sm" data-id="element-657">
                    Open 24 Hours
                  </span>
                </div>
                <div className="flex gap-3" data-id="element-658">
                  <a href={loc.maps} target="_blank" rel="noopener noreferrer" className="flex-1 text-center font-bold text-sm py-2.5 transition-colors duration-200" style={{
                border: '2px solid #1A3BCC',
                color: '#1A3BCC'
              }} onMouseEnter={e => {
                e.currentTarget.style.background = '#1A3BCC';
                e.currentTarget.style.color = '#fff';
              }} onMouseLeave={e => {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.color = '#1A3BCC';
              }} data-id="element-659">
                    Directions
                  </a>
                  <a href="tel:3012549001" className="flex-1 text-center text-white font-bold text-sm py-2.5 transition-colors duration-200" style={{
                background: '#CC0000'
              }} onMouseEnter={e => e.currentTarget.style.background = '#AA0000'} onMouseLeave={e => e.currentTarget.style.background = '#CC0000'} data-id="element-660">
                    Call Now
                  </a>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Community CTA Banner */}
      <section className="relative w-full overflow-hidden py-20 px-4 sm:px-6 lg:px-8" data-id="element-661">
        <img src="https://images.unsplash.com/photo-1522529599102-193c0d76b5b6?w=1600&q=80" alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover" data-id="element-662" />
        <div className="absolute inset-0 bg-black/75" data-id="element-663" />
        <div className="relative z-10 text-center max-w-3xl mx-auto" data-id="element-664">
          <p className="text-xs font-bold uppercase mb-4" style={{
          color: '#FECB00',
          letterSpacing: '0.25em'
        }} data-id="element-665">
            DMV's Most Trusted
          </p>
          <h2 className="font-black text-white text-3xl sm:text-5xl mb-4 leading-tight" data-id="element-666">
            Ready to Experience the Ameritech Difference?
          </h2>
          <p className="text-base mb-10" style={{
          color: 'rgba(255,255,255,0.70)'
        }} data-id="element-667">
            Drive in anytime — no appointment needed. All 3 locations open 24
            hours.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-668">
            <Link to="/contact" className="inline-block text-white font-black uppercase tracking-widest px-10 py-4 text-sm transition-colors duration-200" style={{
            background: '#CC0000',
            letterSpacing: '0.12em'
          }} onMouseEnter={e => e.currentTarget.style.background = '#AA0000'} onMouseLeave={e => e.currentTarget.style.background = '#CC0000'} data-id="element-669">
              Book a Service
            </Link>
            <Link to="/locations" className="inline-block font-black uppercase tracking-widest px-10 py-4 text-sm transition-colors duration-200" style={{
            border: '2px solid white',
            color: 'white',
            letterSpacing: '0.12em'
          }} onMouseEnter={e => {
            e.currentTarget.style.background = 'white';
            e.currentTarget.style.color = '#000';
          }} onMouseLeave={e => {
            e.currentTarget.style.background = 'transparent';
            e.currentTarget.style.color = 'white';
          }} data-id="element-670">
              Find a Location
            </Link>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <TestimonialsSection data-id="element-671" />
    </div>;
}